<!-- 订单物流管理 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
            <supplierBankAction v-if="showStatus" ref="supplierBankAction" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></supplierBankAction>
        </el-drawer>
        <subComponents ref="showSelectData"></subComponents>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <v-search v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">

                </v-search>
            </div>
        </div>
        <div class="page_content_center">
            <el-table @sort-change="sortChange" show-summary :summary-method="getSummaries" v-if="pageShowData.jurTableVo" stripe @selection-change="selectChange" :data="returnData.list" :height="tableHeight"
                      :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini">
                <el-table-column type="selection" width="40"> </el-table-column>
                <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" >
                    <el-table-column :key="tableKey" align="center" v-if="tableValye.isShow == 1" show-overflow-tooltip :prop="tableValye.entityField" :min-width="tableValye.fieldWeight" :label="tableValye.showField"
                                     :sortable="tableValye.isSort == 1 && tableValye.fieldType == 'number' ? 'custom' : tableValye.isSort == 1 ? true : false">
                        <template slot-scope="scope">
                            <el-tag size="mini" v-if="tableValye.entityField == 'isWms'">
                                {{ scope.row.isWms == 0 ? '否' : '是' }}
                            </el-tag>
                            <el-tag size="mini" v-else-if="tableValye.entityField == 'psomState'">
                                {{ $common.getIsGsp(tableValye.formatterContent, scope.row.psomState) }}</el-tag>
                            <span v-else-if="tableValye.fieldType == 'date'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(Number(scope.row[tableValye.entityField])) }}
                                </span>
                            </span>
                            <span v-else-if="tableValye.fieldType == 'formatter'">
                                <span v-for="(item,index) in JSON.parse(tableValye.formatterContent)" :key="index">
                                    <span v-if="item.key == scope.row[tableValye.entityField]">
                                        <el-tag size="mini">{{ item.value }}</el-tag>
                                    </span>
                                </span>
                            </span>
                            <template v-else-if="tableValye.entityField == 'uploadVoList'">
                                <template v-if="scope.row.uploadVoList">
                                    <cusImage style="width: 20px; height: 20px" v-for="(item, key) in scope.row.uploadVoList" :key="key" :src="imgUrl + '/' + item.fileUrl"
                                              :preview-src-list="pictureShow(scope.row.uploadVoList)"></cusImage>
                                </template>
                            </template>
                            <template v-else-if="tableValye.entityField == 'routemapImg'">
                                <cusImage v-if="scope.row.routemapImg" style="width: 20px; height: 20px" :src="imgUrl + '/' + item.routemapImg" :preview-src-list="pictureShow(scope.row.routemapImg)"></cusImage>
                            </template>
                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField] }}</a>
                            </span>
                            <span v-else>
                                {{ scope.row[tableValye.entityField] }}
                            </span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :smId="smId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
        <el-drawer :close-on-press-escape="true" :visible.sync="wlVisible" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="400px">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED">
                <v-tabs :type="1" :activeName="'维护物流信息'" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }">
                    <template slot="tabs" slot-scope="scope">
                        <div v-if="scope.index == 0">
                            <el-form :model="wlInfo" class="baseForm" label-width="100px">
                                <el-row>
                                    <el-form-item label="物流公司" prop="companyName">
                                        <el-tooltip class="item" :disabled="wlInfo.companyName==null||wlInfo.companyName==''?true:false || wlInfo.companyName.length<=9" effect="dark" :content="wlInfo.companyName"
                                                    placement="bottom-start">
                                            <el-input clearable v-model="wlInfo.companyName" @keyup.enter.native="openSearch({sId:'578295613558784',index: 0,type: 'companyName1',sField: 'companyName,loId'})">
                                                <el-button @click="openSearch({sId:'578295613558784',index: 0,type: 'companyName1',sField: 'companyName,loId'})" slot="append" icon="el-icon-search"></el-button>
                                            </el-input>
                                        </el-tooltip>
                                    </el-form-item>
                                    <el-form-item label="物流单号" prop="logisticsNum">
                                        <el-input v-model="wlInfo.logisticsNum" clearable></el-input>
                                    </el-form-item>
                                    <el-form-item label="物流费用" prop="logisticsMoney">
                                        <el-input v-model="wlInfo.logisticsMoney" clearable></el-input>
                                    </el-form-item>
                                    <el-form-item label="司机" prop="driverName">
                                        <el-input v-model="wlInfo.driverName" clearable></el-input>
                                    </el-form-item>
                                    <el-form-item label="车牌号" prop="vmLicensecode">
                                        <el-input v-model="wlInfo.vmLicensecode" clearable></el-input>
                                    </el-form-item>
                                    <el-form-item label="启运温度" prop="coldStrantem">
                                        <el-input v-model="wlInfo.coldStrantem" clearable>
                                            <template slot="append">°C</template>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item label="温控设备" prop="coldControl">
                                        <el-input v-model="wlInfo.coldControl" clearable></el-input>
                                    </el-form-item>
                                    <el-form-item label="保温时限" prop="coldTimeLimit">
                                        <el-input v-model="wlInfo.coldTimeLimit" type="number" clearable></el-input>
                                    </el-form-item>
                                    <el-form-item label="装载环境温度" prop="coldLoadingTem">
                                        <el-input v-model="wlInfo.coldLoadingTem" clearable>
                                            <template slot="append">°C</template>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item label="启运日期" prop="startTem">
                                        <el-date-picker v-model="wlInfo.startTem" type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                                        </el-date-picker>
                                    </el-form-item>
                                    <el-form-item label="起运时间" prop="startTime">
                                        <el-time-picker v-model="wlInfo.startTime" :picker-options="{selectableRange: '00:00:00 - 23:59:59'}" value-format="HH:mm:ss" clearable placeholder="选择时间">
                                        </el-time-picker>
                                    </el-form-item>
                                    <el-form-item label="图片信息" prop="uploadVoList">
                                        <el-upload class="upload-demo" :action="requesUrl + '/upload/fileupload'" :headers='token' :multiple="true" :on-success="fileUpload" :on-remove="handleRemove"
                                                   :before-remove="beforeRemove" :file-list="fileList" list-type="picture">
                                            <el-button size="small" type="primary">点击上传</el-button>
                                            <!-- <div slot="tip" class="el-upload__tip">不超过500kb</div> -->
                                        </el-upload>
                                    </el-form-item>
                                </el-row>
                            </el-form>
                        </div>
                    </template>
                </v-tabs>
            </el-card>

            <div class="foots">
                <el-button type="primary" @click="subWlInfo">确认修改</el-button>
            </div>
        </el-drawer>
        <el-drawer :close-on-press-escape="true" :visible.sync="editVisible" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="50%">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="this.pageShowData.jurFormVoList">
                    <v-tabs :type="1" :activeName="'登记到货信息表单'" :name="'jciName'" :value="'jciName'" :tabslist="this.pageShowData.jurFormVoList" @tabs="(val) => { showTabs = val }">
                        <template slot="tabs" slot-scope="scope">
                            <!-- 主要信息 -->
                            <div v-if="scope.index == 0" class="table_content_box">
                                <el-form label-width="120px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                                    <el-row>
                                        <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" >
                                            <el-form-item v-if="formOneValue.isShow == 1" :key="formOneKey" :label="formOneValue.showField" :prop="formOneValue.entityField"
                                                          :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                                <!-- 日期 -->
                                                <df-date v-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]" :isdisabled="formOneValue.isChange == 0">
                                                </df-date>
                                                <!-- 普通日期 -->
                                                <el-date-picker v-else-if="formOneValue.entityField == 'endDate' || formOneValue.entityField == 'startTem'" v-model="sendDataInfo[formOneValue.entityField]"
                                                                format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" style="width:193px" type="date" :placeholder="'选择' + formOneValue.showField"
                                                                :isdisabled="formOneValue.isChange == 0">
                                                </el-date-picker>
                                                <!-- 普通时间 -->
                                                <el-time-picker v-model="sendDataInfo[formOneValue.entityField]" style="width:193px"
                                                                v-else-if="formOneValue.entityField == 'startTime' || formOneValue.entityField == 'endTime'" format="HH:mm:ss" value-format="HH:mm:ss"
                                                                :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }" :placeholder="'选择' + formOneValue.showField">
                                                </el-time-picker>
                                                <el-input @keyup.enter.native="nextFocus(formOneKey)" v-else-if="formOneValue.entityField == 'salesNumber'" :disabled="formOneValue.isChange == 0"
                                                          v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                                                <!-- string类型 -->
                                                <el-input @keyup.enter.native="nextFocus(formOneKey)" v-else :disabled="formOneValue.isChange == 0" v-model.trim="sendDataInfo[formOneValue.entityField]"
                                                          :maxlength="$store.state.inputLength"></el-input>
                                            </el-form-item>
                                        </template>
                                    </el-row>
                                </el-form>
                                <div>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <div class="foots">
                    <el-button type="primary" @click="subEdit('sendDataInfo')">确认修改</el-button>
                </div>
            </div>
        </el-drawer>
        <el-dialog :visible.sync="wuliuShow" title="上传物流轨迹" append-to-body center width="80%" top="2rem">
            <div class='components_content_box'>
                <el-form label-width="150px" label-position="right" size="mini" class="baseForm" :model="wuliuObj" ref="wuliu" :show-message="false">
                    <el-row :span="24">
                        <el-col :span="12">
                            <el-form-item label="上传图片">
                                <div>
                                    <input style="display: none;" type="file" id="recordExcel" accept="image/*" name="recordExcel" @change="(e) => { fileUploads(e.target.files, e.target.files.length, 0, e) }" />
                                    <label for="recordExcel" class="image_label">点击上传</label>
                                </div>
                                <ul class="uploadList">
                                    <li v-for="(val, key) in wuliuObj.fileList" :key="key" class="image">
                                        <i class="el-icon-error del" @click="delRemove(key)"></i>
                                        <el-image style="width: 98px; height: 98px" :src="`${imgUrl}/${val}`" fit="contain" :preview-src-list="[`${imgUrl}/${val}`]"></el-image>
                                    </li>
                                </ul>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div style="margin-top:.2rem;text-align:center;">
                    <el-button type="primary" @click="initActionBox('wuliu')">取消
                    </el-button>
                    <el-button type="primary" @click="wuliuClick('wuliu')">
                        确定</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Vue from "vue";
import SearchScheme from "@/byComponents/SearchScheme.vue";
import ExtractionScheme from "@/byComponents/ExtractionScheme.vue";
import supplierBankAction from "@/components/supplierBankAction.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        ExtractionScheme,
        supplierBankAction,
    },
    data() {
        //这里存放数据
        return {
            token: {
                token: sessionStorage.getItem("token"),
            },
            editVisible: false,
            sendDataInfo: {},
            tableHeight: 0,
            wlInfo: {
                companyName: '',
                logisticsNum: '',
                logisticsMoney: '',
                coldStrantem: "",
                coldControl: "",
                coldTimeLimit: "",
                startTime: "",
                coldLoadingTem: "",
                startTem: "",
                ids: [],
                uploadVoList: [],
                driverName: '',
                vmLicensecode: '',
            },
            getRequestData: {
                companyName: "",
                page: 1,
                rows: 30,
                loId: "",
                coName: '',
                coId: '',
                start: '',
                end: ''
            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            wlVisible: false,
            tabForm: [
                {
                    jciName: "维护物流信息",
                    jurconfigform: []
                }
            ],
            buttonList: [],
            pageShowData: [],
            formDataList: [],
            selectedDataIndex: 0,
            exId: "",
            seId: "",
            ceshi: "",
            dialogTitle: "",
            seWidth: "",
            height: "",
            exTitle: "",
            seTitle: "",
            seWidth: "",
            exWidth: "",
            DialogVisible: false,
            DialogExtract: false,
            seType: "",
            smId: "",
            isShowTooltip: false,
            showStatus: false,
            actionData: {},
            parentSearchData: {},
            sField: "",
            selectList: [],
            requesUrl: '',
            imgUrl: '',
            ormId: '',
            token: {
                token: sessionStorage.getItem("token"),
            },
            fileList: [],
            uploadVoList: [],
            fileIdlist: [],
            wuliuShow: false,
            wuliuObj: {
                fileList: [],
            }
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "getRequestData.companyName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.getRequestData.loId = "";
                }
            },
            deep: true,
        },
        "getRequestData.coName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.getRequestData.coId = "";
                }
            },
            deep: true,
        },
        editVisible() {
            if (!this.editVisible) {
                for (const key in this.sendDataInfo) {
                    this.sendDataInfo[key] = ''
                }
            }
        },
    },
    //方法集合
    methods: {
        sortChange(column) {
            this.returnData.list = this.$common.sortChange(column, this.returnData.list, this.pageShowData.jurTableVo.jurconfigtable, 'entityField')
        },
        delRemove(key) {
            this.wuliuObj.fileList.splice(key, 1)
        },
        async fileUploads(files, length, index, e) {
            if (length - 1 >= index) {
                if (this.wuliuObj.fileList.length == 1) {
                    return this.$message.error("只能上传一张")
                }
                console.log(files[index]);
                const params = {
                    file: files[index]
                }
                const response = await this.$http.uploadimgUploadPath(params, true)
                console.log(response);
                if (response.status == 200) {
                    this.wuliuObj.fileList.push(response.result)
                    this.fileUploads(files, length, index + 1, e)
                } else {
                    this.$message.error(res.message)
                }
            } else {
                e.target.value = ""
            }
        },
        //取消
        initActionBox(formName1) {
            this.$confirm('确定取消登记吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$refs[formName1].resetFields()
                this.wuliuShow = false
            }).catch(() => { });
        },
        //确认新增
        wuliuClick(formName1) {

            this.$refs[formName1].validate((valid) => {
                if (valid) {
                    // console.log('send', this.sendDataInfo)
                    this.subs(formName1)
                } else {
                    this.$message({
                        message: '请完善必填信息',
                        type: 'error'
                    })
                    return false;
                }
            })
        },
        async subs(formName1) {
            var arr = []
            this.selectList.forEach(item => {
                arr.push(item.spId)
            })
            const params = {
                ids: arr,
                routemapImg: this.wuliuObj.fileList.join()
            }
            var responseData = await this.$http.logisticsOrderuplodRoutemapImg(params)
            if (responseData.status == 200) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.$refs[formName1].resetFields()
                this.wuliuShow = false
                this.getDataList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        subEdit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.sub()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        async sub() {
            var arr = []
            this.selectList.forEach(item => {
                arr.push(item.coldId)
            })
            this.sendDataInfo.coldIds = arr
            console.log(this.sendDataInfo);
            const responseData = await this.$http.updateColdData(this.sendDataInfo)
            console.log(responseData);
            if (responseData.status == 200) {
                this.$message.success("操作成功")
                this.getDataList();
                this.editVisible = false
            }
        },
        //图片地址转换
        pictureShow(data) {
            var imgList = [];
            data.forEach((item) => {
                imgList.push(this.imgUrl + "/" + item.fileUrl);
            });
            return imgList;
        },
        async fileUpload(event) {
            if (this.naum == 1) {
                event.result.forEach((item, index) => {
                    this.wlInfo.uploadVoList.push(item);
                });
            } else {
                event.result.forEach((item, index) => {
                    this.uploadVoList.push(item);
                });
            }
        },
        handleRemove(file, fileList) {
            if (this.naum == 1) {
                this.wlInfo.uploadVoList.forEach((val, i) => {
                    if (file.name == val.fileName) {
                        this.wlInfo.uploadVoList.splice(i, 1);
                    }
                });
            } else {
                this.uploadVoList.forEach((item, index) => {
                    if (file.name == item.fileName) {
                        this.uploadVoList.splice(index, 1);
                    }
                });
            }
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${file.name}？`);
        },
        async fileUpload(event) {
            if (this.naum == 1) {
                event.result.forEach((item, index) => {
                    this.wlInfo.uploadVoList.push(item);
                });
            } else {
                event.result.forEach((item, index) => {
                    this.uploadVoList.push(item);
                });
            }
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                } else if (column.property == 'logisticsMoney') {
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                    } else {
                        sums[index] = '';
                    }
                } else {
                    sums[index] = '';
                    return;
                }
            });
            return sums;
        },
        //获取图片存取的根路径
        imgurl() {
            // console.log(this.$store.getters.getConfig);
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
            this.imgUrl = this.$store.getters.getConfig.imgUrl;
        },
        //  导出
        exportData() {
            window.location.href = this.requesUrl + '/logisticsOrder/exportLogisticsOrder' + this.$common.getUrl(this.getRequestData)
        },
        selectChange(val) {
            this.selectList = val
        },
        //  维护物流信息
        async subWlInfo() {
            let ids = []
            this.selectList.forEach(item => {
                ids.push(item.spId)
            })
            this.wlInfo.ids = ids
            this.wlInfo.uploadVoList = this.uploadVoList;
            // console.log('this.wlInfo', this.wlInfo);
            let responseData = await this.$http.updateLogisticsOrderWl(this.wlInfo)
            if (responseData.status == 200) {
                this.$message({
                    type: 'success',
                    message: responseData.message,
                });
                this.wlVisible = false
                this.getDataList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        // 子组件触发
        drawerCancel(commitData) {
            this.showStatus = false
            commitData && this.getDataList()
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页
                var isPenetrate = true;
                // 设置缓存 存入点击单号
                this.resetSetItem("penetrateOrderId", orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({
                    //向窗口发送MessageEvent消息
                    cmd: "returnFormJson",
                    params: {
                        isPenetrate
                    }, //参数
                },
                    "*"
                );
            }
        },
        //检索带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val);
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            if (this.seType == 'companyName1') {
                arr.forEach((item) => {
                    this.wlInfo[item] = val[item];
                });
                return
            }
            arr.forEach((item) => {
                this.getRequestData[item] = val[item];
            });
        },
        getSeWidth(e) {
            console.log(e);
            this.seWidth = e + "%";
        },
        getWidth(e) {
            console.log(e);
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            console.log(e);
            this.seTitle = e;
        },
        getExtractName(e) {
            console.log(e);
            this.exTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        openSearch({ sId, index, type, sField }) {
            console.log(type)
            this.DialogVisible = true;
            this.seId = sId;
            this.sField = sField;
            this.seType = type
            this.parentSearchData[type] = this.getRequestData[type];
        },
        isShowData(name, value) {
            switch (name) {
                case "supplier":
                    var dataInfo = sessionStorage.getItem("selectSupplierData");
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.getRequestData.psomBuycus = dataInfo.smId;
                        this.getRequestData.smName = dataInfo.smName;
                    }
                    break;
            }
        },

        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path);
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId]
            });
            if (responseData.status == 200) {
                this.pageShowData = responseData.result;
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.formDataList = this.pageShowData.jurFormVoList;
                this.pageShowData.jurFormVoList[0].jurconfigform.forEach(item => {
                    if (item.fieldType == 'search' && item.setField) {
                        var arr = item.setField.split(",")
                        arr.forEach(item1 => {
                            this.$set(this.sendDataInfo, item1, '')
                        })
                    } else if (item.fieldType == 'number') {
                        this.$set(this.sendDataInfo, item.entityField, 0)
                    } else {
                        this.$set(this.sendDataInfo, item.entityField, "")
                    }
                })
                this.getDataList();
                this.getButtonList();
                // this.formDataList = [];
                // this.pageShowData.forEach((item, i) => {
                //   if (i > 3) this.formDataList.push(this.pageShowData[i]);
                // });
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 动作集合
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 0:
                    this.showStatus = true;
                    this.actionData = {
                        cate: 0,
                        formData: this.formDataList,
                        oldData: "",
                        orderId: "",
                        printSouce: "",
                        printJurId: "",
                    };
                    break;
                case 1:
                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    if (this.selectList.length != 1) {
                        this.$message({
                            message: "请先选中一条要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.showStatus = true;
                    this.actionData = {
                        cate: 1,
                        formData: this.formDataList,
                        oldData: dataInfo,
                        orderId: dataInfo.psomId,
                        printSouce: "",
                        printJurId: "",
                    };
                    break;
                case 2:
                    this.delDataAction();
                    break;
                case 3:
                    this.openWl()
                    break;
                case 4:
                    if (this.returnData.list.length == 0) {
                        this.$message({
                            message: "暂无数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.exportData()
                    break;
                case 5:
                    if (this.selectList.length == 0) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.editVisible = true;
                    break;
                case 6:
                    if (this.selectList.length == 0) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    var flag
                    this.wuliuObj.fileList = []
                    this.selectList.forEach(item => {
                        if (item.routemapImg && !flag) {
                            this.wuliuObj.fileList = [item.routemapImg]
                            flag = true
                        }
                    })
                    this.wuliuShow = true;
                    break;
            }
        },
        async openWl() {
            if (this.selectList.length < 1) {
                this.$message({
                    message: '至少选中一条数据维护！',
                    type: 'error'
                });
                return false
            }
            if (this.selectList.length >= 2) {
                for (let key in this.wlInfo) {
                    this.wlInfo[key] = ''
                }
                this.wlInfo['ids'] = []
                this.wlInfo['uploadVoList'] = []
                this.wlInfo['fileList'] = []
                this.wlVisible = true
            } else if (this.selectList.length == 1) {
                const responseData = await this.$http.logisticsOrderqueryDetail({ ids: [this.selectList[0].spId] })
                console.log(responseData);
                for (let key in this.wlInfo) {
                    this.wlInfo[key] = responseData.result[key]
                }
                this.wlInfo['ids'] = [responseData.result.spId]
                this.wlInfo['uploadVoList'] = responseData.result.uploadVoList || []
                this.fileList = responseData.result.uploadVoList || []
                this.fileList.forEach(e => {
                    e.url = window.global_config.BASE_IMG_URL + '/' + e.fileUrl
                    e.name = e.fileName
                })
                this.wlVisible = true
            }

        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.queryLogisticsOrder(
                this.getRequestData
            );
            if (responseData && responseData.status == 200) {
                let resData = JSON.parse(JSON.stringify(responseData));
                this.returnData.list = resData.result.list;
                this.returnData.pages = resData.result.pages;
                this.returnData.total = resData.result.total;
                this.returnData.pageNum = resData.result.pageNum;
                this.selectedDataIndex = 0;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 删除数据
        delDataAction() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }

            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: [dataInfo.sbiId],
                    };
                    let responseData = await this.$http.deleteSupBankinfo(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },

        //获取状态
        getIsGsp(str, val) {
            try {
                str && str.replace(/\\/g, "");
                let arr = JSON.parse(str);
                let len = arr.length;
                let newStr = "";
                for (let i = 0; i < len; i++) {
                    if (arr[i].key === val) {
                        newStr = arr[i].value;
                        break;
                    }
                }
                return newStr;
            } catch (ex) {
                return str;
            }
        },

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
// 初始化时间
        initTime() {
            this.getRequestData.start = this.$common.getStartTime()
            this.getRequestData.end = this.$common.getEndTime()
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo();
        this.initTime()
        this.imgurl()
        this.ormId = sessionStorage.getItem('ormId')
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.el-drawer {
    outline: none;
}
/* 图片上传样式 */
.uploadList {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 100px;
    list-style: none;
}

.image {
    position: relative;
    width: 100px;
    height: 100px;
    margin-right: 5px;
    margin-bottom: 5px;
    flex-shrink: 0;
    border: 1px solid #f3f3f3;
}

.image:nth-child(5n) {
    margin-right: 0;
}

.del {
    display: none;
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 18px;
    z-index: 99;
    cursor: pointer;
}

.del:hover {
    color: #409eff;
}

.image:hover .del {
    display: inline-block;
}

.image_label {
    cursor: pointer;
    padding: 7px 10px !important;
    font-size: 12px !important;
    background-color: #409eff;
    color: #ffffff;
    line-height: 14px;
    margin-right: 5px;
    border-radius: 3px;
}

::v-deep .el-image__error {
   font-size: 7px;
}
</style>